import { createContext } from 'react';
import type { CardData } from 'types/story';

export const CardRendererContext = createContext<{
	card: CardData;
	nextDefaultCardId: string;
	isAnswerSelectionBusy: () => boolean;
	setAnswerSelectionBusy: (busy: boolean) => void;
} | null>(null);
